import React, {} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import {defaultTableHeaderStyles, defaultPaginationOptions, customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle, TableActionIconGeneric} from "./BaseTableComponents";

import PassportTable, { xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import './Table.scss'

const TableOutcomeReviews = (props) =>
{
  const yearFormatter = (cell, row) =>
  {
    return row.year_start + " - " + +(+row.year_start + 1)
  }

  const dateFromFormatter = (cell, row) =>
  {
    return row.date_from + " - " + row.date_to
  }

  const actionFormatter = (cell, row) =>
  {
    if ( row.date_created !== null )
    {
      return row.date_created
    }
    else
    {
      if ( row.progress_review_disabled === null )
      {
        return <TableActionIconGeneric text={ 'Create Review Requests for ' + row.description} color='#5cb85c' icon='glyphicon-export' onClick={() => props.clickHandler(row.year_term_id)}/>
      }
      else
      {
        return 'Skipped'
      }
    }
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    year_start: {borderRadius: defaultTopLeftCellStyle, width: "10vw"},
    description: {width: "10vw"},
    date_from: {width: "12vw"},
    resit: {borderRadius: defaultTopRightCellStyle, textAlign: 'center', width: "6vw"}
  });

  const getColumns = () => {
    const columns = [
      {
        dataField: "year_start",
        text: "Year",
        formatter: yearFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "description",
        text: "Term",
        sort: false,
        headerStyle: headerStyle
      },
      {
        dataField: "date_from",
        text: "Term Dates",
        formatter: dateFromFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "resit",
        text: "Date Created",
        align: 'center',
        formatter: actionFormatter,
        headerStyle: headerStyle
      },
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, []);

  const tableContent = () =>
  {
    return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions} showSearch={false}/>

  }

  return props.loading === true ? <SpinnerDiv/> : tableContent();
}

export default TableOutcomeReviews;
